<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Região" subTitle="Editar" />

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom">
            <h6 class="m-0">Informações da Região</h6>
          </div>
          <!-- Content -->
          <region-form />
          <div class="card-body p-6 pb-3 text-left">
            <Assignment
              storeName="region"
              :onShowText="onShowText"
              :getAssociatedDistributors="getRegionDistributors"
              :syncAttacherDistributors="syncAttacherDistributors"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import Assignment from '_shared/Assignment.vue';
import RegionForm from '../components/RegionForm.vue';
import { _LOAD_MODEL_ } from '../components/RegionModel';

export default {
  name: 'admin-region-edit',
  components: {
    PageHeader,
    Assignment,
    RegionForm,
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'checkAdmin',
      'getRegion',
      'syncAttacherDistributors',
      'getRegionDistributors',
    ]),
    getRegionModel(id) {
      this.setToggle({ type: 'progress', bool: true });
      this.getRegion(id)
        .then(response => {
          Events.$emit(_LOAD_MODEL_, response);
          this.setToggle({ type: 'progress', bool: false });
        })
        .catch(error => {
          this.activeAlert({ message: error, theme: 'danger' });
        });
    },
    onShowText(item) {
      if (item.name && item.uf) return `${item.name} - ${item.uf}`;
      return item.name;
    },
  },
  mounted() {
    this.checkAdmin();
    if (this.$route.params.id) {
      return this.getRegionModel(parseInt(this.$route.params.id, Number));
    }
    return null;
  },
};
</script>
